import React from 'react';
import paperAeroplane from '../assets/paper-aeroplane.svg';
import EmptyState from '@atlaskit/empty-state';
import messages from '../messages';
import { injectIntl, type WrappedComponentProps } from 'react-intl-next';
import ViewTracker from '../../../common/analytics/view-tracker';
import { ContextualAnalyticsData, SCREEN } from '@atlassian/analytics-bridge';

interface OwnProps {
	crossJoinProjectExperimentCohort?: string;
}

const PendingRequest = injectIntl(
	({
		intl: { formatMessage },
		crossJoinProjectExperimentCohort = 'not-enrolled',
	}: WrappedComponentProps & OwnProps) => {
		const inCrossJoinVariation = crossJoinProjectExperimentCohort === 'variation';
		return (
			<>
				<EmptyState
					imageUrl={paperAeroplane}
					imageHeight={95}
					imageWidth={124}
					header={formatMessage(messages.requestAccessPendingRequestTitle)}
					description={formatMessage(
						inCrossJoinVariation
							? messages.requestAccessPendingRequestSubtitleExp
							: messages.requestAccessPendingRequestSubtitle,
					)}
					testId="confluence-project-pages.cross-join.pending-request"
				/>
				<ViewTracker />
			</>
		);
	},
);

export default (props: OwnProps) => (
	<ContextualAnalyticsData sourceName="projectPagesPendingRequest" sourceType={SCREEN}>
		<PendingRequest {...props} />
	</ContextualAnalyticsData>
);
